import { Link } from 'react-router-dom';
import { Heart, Home, Share2, Users, ArrowRight } from 'lucide-react';
import PublicNav from '../components/PublicNav';
import PublicFooter from '../components/PublicFooter';

const DonateThankYou = () => {
  const shareUrl = 'https://www.straydog-secondstory.org/donate';
  const shareText = 'I just supported Second Story Initiative — a nonprofit helping justice-impacted individuals build tech careers. Consider joining me!';

  return (
    <div className="min-h-screen bg-white">
      <PublicNav />

      <main id="main-content">
        <section
          aria-labelledby="thankyou-heading"
          className="relative bg-secondary-950 py-24 sm:py-32 overflow-hidden"
        >
          <div
            aria-hidden="true"
            className="absolute inset-0 opacity-15 animate-gradient-shift"
            style={{
              backgroundImage:
                'radial-gradient(circle at 25% 50%, rgba(53,94,59,0.4) 0%, transparent 50%), radial-gradient(circle at 75% 20%, rgba(53,94,59,0.2) 0%, transparent 45%)',
              backgroundSize: '200% 200%',
            }}
          />
          <div className="relative max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="inline-flex items-center justify-center h-20 w-20 rounded-full bg-success-500/20 border border-success-500/30 mb-8">
              <Heart className="h-10 w-10 text-success-400" />
            </div>
            <h1
              id="thankyou-heading"
              className="font-display text-4xl sm:text-5xl font-bold text-white mb-6 leading-tight tracking-tight"
            >
              Thank You
            </h1>
            <p className="text-lg sm:text-xl text-secondary-300 leading-relaxed mb-10">
              Your generosity directly supports justice-impacted individuals building new careers
              in technology. We will email you a confirmation of your gift.
            </p>

            {/* Share buttons */}
            <div className="mb-12">
              <p className="text-sm font-semibold text-secondary-400 uppercase tracking-widest mb-4">
                Spread the Word
              </p>
              <div className="flex flex-wrap gap-3 justify-center">
                <a
                  href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn border border-white/20 text-white hover:bg-white/10 inline-flex items-center no-underline hover:no-underline text-sm"
                >
                  <Share2 className="h-4 w-4 mr-2" />
                  Share on X
                </a>
                <a
                  href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn border border-white/20 text-white hover:bg-white/10 inline-flex items-center no-underline hover:no-underline text-sm"
                >
                  <Users className="h-4 w-4 mr-2" />
                  Share on LinkedIn
                </a>
              </div>
            </div>

            {/* Next steps */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/"
                className="btn btn-lg bg-primary-600 text-white hover:bg-primary-500 inline-flex items-center shadow-md no-underline hover:no-underline"
              >
                <Home className="mr-2 h-5 w-5" />
                Back to Home
              </Link>
              <Link
                to="/about"
                className="btn btn-lg border-2 border-white/70 text-white hover:bg-white/10 inline-flex items-center no-underline hover:no-underline"
              >
                Learn More About Us
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </div>
          </div>
        </section>
      </main>

      <PublicFooter />
    </div>
  );
};

export default DonateThankYou;
